import type { AddEthereumChainParameter } from 'viem';

import type config from 'configs/app';
import { getHexadecimalChainId } from 'lib/web3/utils';

export default function getAddEthereumChainParams(
  chainConfig: typeof config,
): AddEthereumChainParameter {
  const id = chainConfig.chain.id;
  if (!id) throw new Error('Missing required chain config');

  return {
    chainId: getHexadecimalChainId(Number(id)),
    chainName: chainConfig.chain.name ?? '',
    nativeCurrency: {
      name: chainConfig.chain.currency.name ?? '',
      symbol: chainConfig.chain.currency.symbol ?? '',
      decimals: chainConfig.chain.currency.decimals ?? 18,
    },
    rpcUrls: chainConfig.chain.rpcUrls,
    blockExplorerUrls: chainConfig.app?.baseUrl ? [ chainConfig.app.baseUrl ] : undefined,
  };
}
